import { createMuiTheme } from '@material-ui/core/styles'

const palette = {
  primary: {
    light: '#8b9cff',
    main: '#5b6cff',
    dark: '#3d4ed8',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#9d8cff',
    main: '#7c6bf2',
    dark: '#5a4bc4',
    contrastText: '#ffffff',
  },
  success: {
    main: '#22c55e',
    light: '#dcfce7',
    dark: '#16a34a',
  },
  warning: {
    main: '#f59e0b',
    light: '#fef3c7',
    dark: '#d97706',
  },
  error: {
    main: '#ef4444',
    light: '#fee2e2',
    dark: '#dc2626',
  },
  info: {
    main: '#38bdf8',
    light: '#e0f2fe',
    dark: '#0284c7',
  },
  background: {
    default: '#f5f7fb',
    paper: '#ffffff',
  },
  text: {
    primary: '#1f2937',
    secondary: '#6b7280',
  },
  divider: '#e5e7eb',
}

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily:
      '"Inter", "Noto Sans TC", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 14,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: palette.background.default,
          color: palette.text.primary,
        },
        a: {
          color: 'inherit',
        },
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 16,
      },
      elevation1: {
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
      },
      elevation2: {
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
      },
    },
    MuiCard: {
      root: {
        borderRadius: 18,
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
        border: '1px solid #eef2f7',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 12,
        padding: '8px 16px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 6px 16px rgba(91, 108, 255, 0.25)',
        },
      },
    },
    MuiFab: {
      root: {
        boxShadow: '0 10px 24px rgba(91, 108, 255, 0.35)',
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: '#ffffff',
        color: palette.text.primary,
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#f3f4f8',
        borderRight: 'none',
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid #eef2f7',
        padding: '14px 16px',
      },
      head: {
        backgroundColor: '#fafbfe',
        color: palette.text.secondary,
        fontWeight: 600,
        fontSize: '0.8rem',
      },
    },
    MuiTableRow: {
      root: {
        '&:hover': {
          backgroundColor: '#f8faff',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 12,
        backgroundColor: '#ffffff',
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 18,
      },
    },
    MuiChip: {
      root: {
        borderRadius: 999,
        fontWeight: 600,
      },
    },
  },
  palette: {
    primary: palette.primary,
    secondary: palette.secondary,
    error: palette.error,
    background: palette.background,
    text: palette.text,
    divider: palette.divider,
  },
  custom: {
    success: palette.success,
    warning: palette.warning,
    info: palette.info,
    sidebarWidth: 248,
    sidebarCollapsedWidth: 84,
    contentMaxWidth: 1440,
    softShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
    cardBorder: '1px solid #eef2f7',
    status: {
      good: '#22c55e',
      warn: '#f59e0b',
      bad: '#ef4444',
      muted: '#94a3b8',
    },
  },
})

export default theme
